import React from "react";
import { Bar } from "react-chartjs-2";
import {  ThemeType } from "../../types";
import {  useNewData, useOptions } from "../../hooks/useGraph";
import { DataType } from "../../types/dataType";
import { dummyData } from "../../contains/dummyData";

export type BarChartProps = {
  className?: string;
  width?: string | number;
  height?: string | number;
  data: DataType;
  theme?: ThemeType;
};

const defaultProps = { data: dummyData };
const BarChart = ({
  data,
  className,
  height,
  width,
  theme,
}: BarChartProps): JSX.Element => {
  const chartData = useNewData(data);
  const opt = useOptions("bar", theme);

  return (
    <Bar
      data={chartData}
      className={className}
      options={opt}
      height={height}
      width={width}
    />
  );
};

BarChart.defaultProps = defaultProps;

export default BarChart;
